import { ApolloClient, from } from '@apollo/client';
import gql from 'graphql-tag';
export class ProductionLineInput {
  id?: number; // optional, for updates
  aa: number;
  productionId: number;
  materialId: number;
  netWeight: number;
  producedMaterials?: ProducedMaterialInput[];

  constructor() {
    this.id = undefined;
    this.aa = undefined;
    this.productionId = undefined;
    this.materialId = undefined;
    this.netWeight = undefined;
    this.producedMaterials = undefined;
  }
}
export class ProducedMaterialInput {
  materialId: number;
  netWeight: number;
  percentage: number;

  constructor() {
    this.materialId = undefined;
    this.netWeight = undefined;
    this.percentage = undefined;
  }
}
export class FormInput {
  id: number;
  code: string;
  seriesId: number;
  codePrefix: string;
  codeNumber: number;
  notes: string;
  productionDate: string;
  fromWastereceptionpointId: number;
  fromCollectionId: number;
  isActive: boolean;
  collectorId: number;
  productionLines: {
    id: number;
    aa: number;
    materialId: number;

    netWeight: number;
    producedMaterials: {
      id: number;
      materialId: number;
      productionLineId: number;
      material: {
        id: number;
        name: string;
      };
      netWeight: number;
      percentage: number;
    };
    material: {
      id: number;
      name: string;
    };
  }[];

  constructor() {
    this.id = undefined;
    this.code = undefined;
    this.seriesId = undefined;
    this.codePrefix = undefined;
    this.codeNumber = undefined;
    this.notes = undefined;
    this.productionDate = undefined;
    this.fromWastereceptionpointId = undefined;
    this.fromCollectionId = undefined;
    this.isActive = undefined;
    this.collectorId = undefined;
    this.productionLines = undefined;
  }
}

export const gqlGetQuery = gql`
  query getProductions($limit: Int, $offset: Int, $order: String, $where: String) {
    getProductions(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        code
        seriesId
        codePrefix
        codeNumber
        notes
        productionDate
        collectorId
        fromWastereceptionpointId
        fromWastereceptionpoint {
          id
          code
          name
          addressLine1
          addressArea
          addressCity
        }
        fromCollectionId
        fromCollection {
          id
          code
        }
        legacyAppId
        recordDate
        isActive
        firstDate
        lastDate
        firstUser
        lastUser

        productionLines {
          id
          aa
          materialId
          netWeight
          material {
            id
            name
          }
          producedMaterials {
            id
            materialId
            material {
              id
              name
            }
            netWeight
          }
        }
      }
      recordCount
    }
  }
`;
export const gqlAddProductionLine = gql`
  mutation addProductionLine($data: ProductionLineInput) {
    addProductionLine(data: $data) {
      id
    }
  }
`;

export const gqlUpdateProductionLine = gql`
  mutation updateProductionLine($data: ProductionLineInput) {
    updateProductionLine(data: $data) {
      id
      aa
      materialId
      material {
        id
        name
      }
      netWeight
      producedMaterials {
        id
        materialId
        productionLineId
        material {
          id
          name
        }
        netWeight
        percentage
      }
      productionId
    }
  }
`;
export const gqlDeleteProductionLine = gql`
  mutation deleteProductionLine($id: Int) {
    deleteProductionLine(id: $id)
  }
`;

export const gqlGetByIdQuery = gql`
  query getProductionById($id: Int) {
    getProductionById(id: $id) {
      id
      code
      seriesId
      codePrefix
      codeNumber
      notes
      productionDate
      fromWastereceptionpointId
      isActive
      collectorId
      collector {
        id
        name
      }
      fromWastereceptionpoint {
        id
        code
        name
      }
      fromCollectionId
      fromCollection {
        id
        code
      }

      productionLines {
        id
        aa
        materialId
        productionId
        netWeight
        producedMaterials {
          id
          materialId
          productionLineId
          material {
            id
            name
          }
          netWeight
          percentage
        }
        material {
          id
          name
        }
      }
    }
  }
`;

export const gqlAdd = gql`
  mutation addProduction($data: ProductionInput) {
    addProduction(data: $data) {
      id
    }
  }
`;
export const gqlUpdate = gql`
  mutation updateProduction($data: ProductionInput) {
    updateProduction(data: $data) {
      id
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteProduction($id: Int!) {
    deleteProduction(id: $id)
  }
`;

export async function getWasteReceptionPointById(
  client: ApolloClient<object>,
  id: number,
): Promise<any> {
  const gqlScript = gql`
    query getWastereceptionpointById($id: Int) {
      getWastereceptionpointById(id: $id) {
        id
        name
        phone
        email
        companyVat
        companyTaxOffice
        addressLine1
        addressLine2
        addressCity
        addressArea
        postalCode
        regionId
        receptionPersonName
      }
    }
  `;
  const ret = await client.query({
    query: gqlScript,
    variables: { id },
    fetchPolicy: 'network-only',
  });

  return ret?.data?.getWastereceptionpointById;
}
